import(/* webpackMode: "eager" */ "/usr/src/app/node_modules/next/dist/client/link.js");
import(/* webpackMode: "eager" */ "/usr/src/app/src/1_components/Buttons/BaseButton/BaseButton.tsx");
import(/* webpackMode: "eager" */ "/usr/src/app/src/3_containers/NotFoundPage/NotFoundPage.module.scss")